var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "ax-searchbar",
      attrs: { id: "ax-searchbar" },
      on: { mouseup: _vm.tryCloseSidebar }
    },
    [
      _c(
        "div",
        { staticClass: "ax-searchbar__left-container" },
        [
          _c(
            "IconButton",
            {
              ref: "nineDotButton",
              staticClass: "ax-searchbar__sidebar-toggle",
              class: { active: _vm.isSidebarOpen },
              attrs: { id: "sidebar-toggle", title: "Open sidebar" },
              nativeOn: {
                click: function($event) {
                  return _vm.toggleSidebar.apply(null, arguments)
                }
              }
            },
            [_c("switch-icon")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ax-searchbar__logo-container" },
            [_c("ClassLogo")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ax-searchbar__center-container" }, [
        _c(
          "div",
          { staticClass: "ax-searchbar__search" },
          [
            _c(
              "div",
              { staticClass: "ax-searchbar__action-icons" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery"
                    }
                  ],
                  ref: "txtSearchBox",
                  staticClass:
                    "\n          ax-input ax-input--text\n          has-icon-trailing\n          ax-input-icon--search\n          ax-input--full-width\n        ",
                  attrs: {
                    type: "text",
                    id: "text-input-id",
                    name: "text-input-id",
                    placeholder: "Search for Entities and Menu items..."
                  },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    focus: _vm.onFocusInSearchbox,
                    mouseup: _vm.onMouseUpInSearchbox,
                    keydown: _vm.onKeyDownInSearchbox,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchQuery = $event.target.value
                    }
                  }
                }),
                _vm.classAgentEnabled
                  ? _c(
                      "IconButton",
                      {
                        ref: "classAgentButton",
                        staticClass: "ax-searchbar__icon-link",
                        attrs: {
                          id: "class-agent-button",
                          href: _vm.classAgentUrl,
                          title: "Class Agent",
                          target: "_blank"
                        }
                      },
                      [
                        _c("ClassAgentIcon", {
                          staticClass:
                            "ax-class-agent__svg ax-class-agent__svg--default",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("ClassAgentIconHover", {
                          staticClass:
                            "ax-class-agent__svg ax-class-agent__svg--hover",
                          attrs: { "aria-hidden": "true" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showResultPanel
              ? _c("MainResultsPanel", {
                  ref: "mainResultsPanel",
                  on: { navigate: _vm.navigate }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ax-searchbar__right-container" }, [
        _c(
          "div",
          { staticClass: "ax-searchbar__action-icons" },
          [
            _c(
              "IconButton",
              {
                ref: "changeBusinessButton",
                staticClass: "ax-searchbar__icon-link",
                attrs: {
                  id: "change-business-button",
                  href: "/my/business-summary?RememberTableState=False",
                  title: "Change business"
                }
              },
              [
                _c("change-business-icon", {
                  staticClass: "ax-change-business__svg"
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.clientViewPath
              ? _c(
                  "IconButton",
                  {
                    ref: "clientViewButton",
                    staticClass: "ax-searchbar__icon-link",
                    attrs: {
                      id: "client-view-button",
                      href: _vm.clientViewPath,
                      title: "Client view",
                      target: "_blank"
                    }
                  },
                  [
                    _c("client-view-icon", {
                      staticClass: "ax-client-view__svg"
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "IconButton",
              {
                ref: "helpPanelButton",
                staticClass: "ax-searchbar__icon-link",
                class: { active: _vm.isHelpPanelOpen },
                attrs: { id: "help-menu-toggle", title: "" },
                nativeOn: {
                  click: function($event) {
                    return _vm.toggleHelp.apply(null, arguments)
                  }
                }
              },
              [
                _c("question-mark-icon", {
                  staticClass: "ax-searchbar-help__svg"
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "IconButton",
              {
                ref: "settingsButton",
                staticClass: "ax-searchbar__icon-link",
                class: { active: _vm.isSettingsPanelOpen },
                attrs: { id: "setting-menu-toggle", title: "My account" },
                nativeOn: {
                  click: function($event) {
                    return _vm.toggleSettings.apply(null, arguments)
                  }
                }
              },
              [
                _c("settings-icon", {
                  staticClass: "ax-searchbar-setting__svg"
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }